export const habaWishlist = {
  wishlistOverview: {
    title: 'My wishlists',
    addNew: 'Create new wishlist',
    noWishlists: 'You do not have wishlists',
    back: 'My wishlists',
    navigation: {
      add: 'Create a new wishlist',
      chooseExisting: 'Or select an existing wishlist',
    },
    list: {
      delete: 'Delte wishlist',
      moveAllToBasket: 'Move all to cart',
      noItems: 'The wishlist does not contain any products yet',
    },
    item: {
      quantity: 'Amount: {{quantity}}',
      articleNr: 'Item number: {{articleNr}}',
      action: {
        cart: 'Add to cart',
        move: 'Move article',
        delete: 'Delete article',
      },
    },
    modal: {
      addedToCart: {
        title: 'The item was added to the cart',
        btn: 'To the cart',
      },
    },
  },
  wishlistCreate: {
    placeholder: 'Wishlist name',
    button: 'Save wishlist',
    successMessage: 'Wishlist created',
    errorLengthMin: 'Name must be greater than 3 letters',
    errorLengthMax: 'Name must be shorter than 100',
    errorExitsAlready: 'Name already exists.',
    errorExitsAlreadyInHabaPlay:
      'You already have a wishlist with the same name on HABA Play. Please enter a different name for the wishlist.',
    emptiedListSuccessMessage: 'Your products have been added to the shopping cart',
    listCreated: 'Wishlist created',
  },
  wishlistEdit: {
    edit: 'Edit wishlist',
    rename: 'Rename wishlist',
    delete: 'Delete wishlist',
    successMessage: 'Liste bearbeitet',
    questionDelete: 'Do you want to delete this list and all products it contains?',
  },
  wishlistList: {
    noItems: 'No items available in this list',
    noItemsButton: 'Check our products',
    allToBasket: 'Add all to basket',
    removedSuccessMessage: 'List removed',
    itemRemovedSuccessMessage: 'Updated list',
    deletedList: 'Your list has been deleted',
    renameList: 'The name of the list has been changed',
  },
  wishlistMove: {
    title: 'Produkt verschieben',
    subtitle: 'Wählen Sie eine Merkliste aus:',
    successMessage: 'Ihr Produkt wurde verschoben',
    warningCartsMessage: 'You only have 1 list',
    newWishlist: 'Or create a new wishlist',
  },
  wishlistAdd: {
    title: 'My wishlist',
    newWishlist: 'Create a new wishlist',
    toExisting: 'Or select an existing wishlist',
    addToWishlist: 'Add to wishlist',
    addToWishlistTitle: 'Add to wishlist',
    addToCartSuccess: 'Your product has been added to the shopping cart',
    warningSelectWishlist: 'You need to select a wishlist first',
    noListsCreatedMessage: "You currently don't have any wishlists created, please create one",
    createWishlistAltText: 'or create a new wishlist',
    addedToWishlist: 'Added to wishlist',
  },
};
